import VendDetect from '@vend/detect'
import angular from 'angular'

import { EVENTS } from '../../constants'
import template from '../../../templates/application/wr-refresh-banner.html'

/**
 * Directive for the banner displayed at the top of the screen when a soft refresh is triggered. Prompts the user to
 * refresh the page to get the latest version of the application.
 *
 * @module webregister.directives.wrRefreshBanner
 */
angular
  .module('webregister.directives')
  .directive('wrRefreshBanner', function () {
    return {
      restrict: 'E',
      template,
      bindToController: true,
      controllerAs: 'refreshBannerCtrl',

      /**
       * =======================================
       * REFRESH BANNER CONTROLLER
       * =======================================
       */
      controller(this: $TSFixMe, $scope, webRegisterStatusManager, vdTracking) {
        const browser = {
          name: VendDetect.Browser,
          version: VendDetect.Version,
        }

        this._updateEnabled = function () {
          this.enabled = webRegisterStatusManager.softRefreshRequired

          if (this.enabled) {
            vdTracking.trackUserEvent({
              eventName: 'Refresh Banner Displayed',
              metadata: { browser },
              useSendBeacon: true,
            })
          }
        }

        /**
         * Refresh the application.
         *
         * @method refresh
         */
        this.refresh = function () {
          vdTracking.trackUserEvent({
            eventName: 'Refresh Banner:  Refresh Now Clicked',
            metadata: { browser },
            useSendBeacon: true,
          })

          webRegisterStatusManager.refreshCacheAndReload({ forceReload: true })

          this.close()
        }

        this.closeBanner = function () {
          vdTracking.trackUserEvent({
            eventName: 'Refresh Banner: Close Clicked',
            metadata: { browser },
            useSendBeacon: true,
          })

          this.close()
        }

        /**
         * Close the banner.
         *
         * @method close
         */
        this.close = function () {
          this.enabled = false
        }

        this._updateEnabled()

        webRegisterStatusManager.on(
          EVENTS.softRefreshRequired,
          this._updateEnabled,
          this
        )
        $scope.$on('$destroy', () => {
          webRegisterStatusManager.off(
            EVENTS.softRefreshRequired,
            this._updateEnabled
          )
        })
      },
    }
  })
